define('helperContent-getSectionEntities',[],function() {
    'use strict';

    // also checks if contentEntity property exist
    var getSectionEntities = function f(arr) {
        //TODO... THIS COULD USE GET LEVEL 1 ENTITIES AS HELPER AND JUST REMOVE PAGES WITH NO CHILDREN
        // var i, res, sections = [], section;
        var sections = [];

        if (!Array.isArray(arr)) {
            return null;
        }

        // i = arr.length;
        arr = [].concat(arr);

        if(arr.length > 0){
            arr.forEach(function(entity){
                if (entity.hasOwnProperty('children') && Array.isArray(entity.children) && entity.children.length) {
                    sections.push(entity);
                }
            });
        }

        return sections;
    };

    return getSectionEntities;
});

